import { CircularProgress } from "@mui/joy";
import { SaveButton } from "../UtilitiesComponents/SaveButton";
import { CancelButton } from "../UtilitiesComponents/CancelButton";
import { useCreateActiveDealManuallyMutation } from "../../api/dealApi";

interface Props {
    empresaId: number;
    onCancelButton?: (cancelAction: boolean) => void;
}

export function ActiveDealOutOfRange({ empresaId, onCancelButton }: Props) {

    const [createDeal, { isLoading }] = useCreateActiveDealManuallyMutation();

    const handleCreateDeal = async () => {
        await createDeal(empresaId);
    }

    return (
        <div className="flex flex-col items-center justify-center p-3">
            <p className="text-xl text-center pb-3">¿Esta seguro en crear una nueva campaña?</p>

            {isLoading
            ?
            <CircularProgress sx={{
                    "--CircularProgress-progressThickness": "4px",
                    "--CircularProgress-trackThickness": "4px",
                    "--CircularProgress-size": "27px"
                }}/>
            :
            <div className="flex gap-x-4">
                <SaveButton
                    text="Crear campaña"
                    onClick={handleCreateDeal}
                    type="button" />

                <CancelButton
                    onClick={()=> {
                        if(onCancelButton)
                            onCancelButton(false);
                    }}/>
            </div>
            }
        </div>
    );
}